import axios from 'axios'
import pubFunction from '../public/index.js'
import {
	Notification
} from 'element-ui'
import store from '../store/index.js'

const requestUrl = pubFunction.requestUrl

// 需要token验证的前端接口
const tokenApi = [
	'MemberApi/createAddress',
	'MemberApi/editAvatar',
	'MemberApi/inputPhoneCode',
	'MemberApi/inputEmailCode',
	'MemberApi/updatePhone',
	'MemberApi/findMemberById',
	'MemberApi/updateEmail',
	'MemberApi/updatePassword',
	'ReceiverAddressApi/addOrUpdateReceiverAddress',
	'ReceiverAddressApi/deleteReceiverAddress',
	'ReceiverAddressApi/findReceiverAddressById',
	'ReceiverAddressApi/findReceiverAddressList',
	'ReceiverAddressApi/setDefaultAddress',
	'BondOrderApi/addBondOrder',
	'BondOrderApi/findBondOrders',
	'BondOrderApi/findBondById',
	'PayApi/wxPay',
	'PayApi/zfbPay',
	'PayApi/query',
	'MyRemindApi/addMyRemind',
	'AutoBidApi/addAutoBid',
	'MyCollectionApi/addMyCollection',
	'MyCollectionApi/deleteMyCollection',
	'MyCollectionApi/findMyCollectionList',
	'BiddingRecordApi/addBiddingRecord',
	'MyTracksApi/addOrUpdateMyTracks',
	'MyTracksApi/findMyTracksList',
	'MyCollectionApi/findMyRemindList',
	'MyRemindApi/deleteMyRemind',
	'MyCollectionApi/findMyCanPaiList',
	'LotOrderApi/findLotOrders',
	'AuctionLotApi/findLotById',
	'LotOrderApi/findLotOrderById',
	'MemberLabelApi/findLabels',
	'MemberLabelApi/queryMemberLabel',
	'MemberLabelApi/setMemberLabel',
	'LotOrderApi/queryOrderStatus'
]
// 非必须token验证的前端接口
const optionalApi = [
	'AuctionLotApi/findAuctionLotById'
]
// 后台管理接口
const adminApi = [
	'userInfo',
	'changePassword',
	'findUserList',
	'addOrUpdateUser',
	'updateUserPwd',
	'updateUserStatus',
	'deleteUser',
	'findMembers',
	'findMemberById',
	'findArticleTypeList',
	'findArticleTypes',
	'addOrUpdateArticleType',
	'findArticleTypeById',
	'deleteArticleType',
	'findArticleList',
	'findArticleById',
	'addOrUpdateArticle',
	'deleteArticle',
	'findPictureList',
	'deletePicture',
	'findPictureById',
	'addOrUpdatePicture',
	'addOrUpdateActivity',
	'closeActivity',
	'deleteActivity',
	'findActivityById',
	'findActivityList',
	'openActivity',
	'findActivitys',
	'findLotTypeList',
	'deleteLotType',
	'findLotTypeById',
	'addOrUpdateLotType',
	'findLotTypes',
	'findLotList',
	'findAuctionLotList',
	'findLots',
	'addAuctionLot',
	'findLabelList',
	'addOrUpdateLabel',
	'deleteLabel',
	'findLabelById',
	'findLabels',
	'findFollowLotList',
	'findFollowUserList',
	'createAuctionLot',
	'updateAuctionLot',
	'downAuctionLot',
	'findAuctionLotById',
	'findBiddingRecord',
	'findBondOrder',
	'upAuctionLot',
	'findLotOrderList',
	'addOrUpdateDadeCompany',
	'findDadeCompanyList',
	'findTongJi',
	'findYueCount',
	'findLotOrderById',
	'refund',
	'refundAll'
]
// 本地token验证
const doRequest = (api, data, type, callback) => {
	let token = ''
	let f = 0
	// 必需token验证
	if (tokenApi.indexOf(api) >= 0) {
		f = 1
		token = pubFunction.getStorage('page_token')
		if (!token) {
			disposeNologin(f)
			return false
		} else {
			axios.defaults.headers.common["Authtoken"] = token
		}
	}
	// 后台token验证
	if (adminApi.indexOf(api) >= 0) {
		f = 2
		token = pubFunction.getStorage('adm_token')
		if (!token) {
			disposeNologin(f)
			return false
		} else {
			axios.defaults.headers.common["Authtoken"] = token
		}
	}
	// 前台非必须token接口
	if (optionalApi.indexOf(api) >= 0) {
		token = pubFunction.getStorage('page_token') ? pubFunction.getStorage('page_token') : ''
		axios.defaults.headers.common["Authtoken"] = token
	}
	let url = requestUrl + api
	sendPost(url, data, type, callback, f)
}
// 统一处理登录失效方法
const disposeNologin = (f) => {
	resetHeader()
	Notification.error({
		title: '发生错误',
		message: '当前登录状态已失效，请您重新登录。',
		duration: 2000,
		onClose: () => {
			if (f == 1) {
				store.commit('logout')
			} else if (f == 2) {
				store.commit('admLogout')
			} else {
				console.log('非校验接口出错')
			}
		}
	})
}
const resetHeader = () => {
	delete axios.defaults.headers.common['token']
}
const disposeError = (msg) => {
	Notification.error({
		title: '发生错误',
		message: msg,
		duration: 2000
	})
}

// 超时时间
axios.defaults.timeout = 20000
axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
	let config = err.config
	if (!config || !config.retry) {
		return Promise.reject(err)
	}
})

// 统一请求方法
const sendPost = (url, data, type, callback, f) => {
	if (type == 'GET') {
		axios.get(url, {
			params: data
		}).then((res) => {
			if (res.data.code == 203) {
				disposeNologin(f)
				return
			} else if (res.data.code != 200) {
				disposeError(res.data.msg)
			}
			callback(res.data)
		}).catch((err) => {
			callback({code:0})
			console.log(err);
		})
	} else {
		axios.post(url, data).then((res) => {
			if (res.data.code == 203) {
				disposeNologin(f)
				return
			} else if (res.data.code != 200) {
				disposeError(res.data.msg)
			}
			callback(res.data)
		}).catch((err) => {
			callback({code:0})
			console.log(err);
		})
	}
}

// 管理端登陆
const admlogin = (data, callback) => doRequest('login', data, 'post', callback)
// 管理端获取用户信息
const admGetUserInfo = (data, callback) => doRequest('userInfo', data, 'GET', callback)
// 管理端修改当前用户密码
const admEditPassword = (data, callback) => doRequest('changePassword', data, 'POST', callback)
// 后台用户列表
const admUserList = (data, callback) => doRequest('findUserList', data, 'POST', callback)
// 新增后台用户
const admUserAdd = (data, callback) => doRequest('addOrUpdateUser', data, 'POST', callback)
// 修改后台用户密码
const admPasswordEdit = (data, callback) => doRequest('updateUserPwd', data, 'POST', callback)
// 修改用户状态
const admUserStatus = (data, callback) => doRequest('updateUserStatus', data, 'GET', callback)
// 删除后台用户
const admUserDelete = (data, callback) => doRequest('deleteUser', data, 'GET', callback)
// 前台用户列表
const normalUserList = (data, callback) => doRequest('findMembers', data, 'POST', callback)
// 查询前台用户信息
const normalUserInfo = (data, callback) => doRequest('findMemberById', data, 'GET', callback)
// 查询文章分类
const articleCategory = (data, callback) => doRequest('findArticleTypeList', data, 'POST', callback)
// 查询所有分类
const articleCategoryAll = (data, callback) => doRequest('findArticleTypes', data, 'POST', callback)
// 增加分类
const articleCategoryAdd = (data, callback) => doRequest('addOrUpdateArticleType', data, 'POST', callback)
// 分类详情
const articleCategoryDetail = (data, callback) => doRequest('findArticleTypeById', data, 'GET', callback)
// 删除分类
const articleCategoryDelete = (data, callback) => doRequest('deleteArticleType', data, 'GET', callback)
// 文章列表
const articleList = (data, callback) => doRequest('findArticleList', data, '', callback)
// 文章详情
const articleDetail = (data, callback) => doRequest('findArticleById', data, 'GET', callback)
// 文章编辑
const articleEdit = (data, callback) => doRequest('addOrUpdateArticle', data, 'POST', callback)
// 文章删除
const articleDelete = (data, callback) => doRequest('deleteArticle', data, 'GET', callback)
// 轮播图列表
const swiperList = (data, callback) => doRequest('findPictureList', data, 'POST', callback)
// 删除轮播图
const swiperDelete = (data, callback) => doRequest('deletePicture', data, 'GET', callback)
// 查询详情
const swiperDetail = (data, callback) => doRequest('findPictureById', data, 'GET', callback)
// 轮播图编辑
const swiperEdit = (data, callback) => doRequest('addOrUpdatePicture', data, 'POST', callback)
// 编辑活动
const activityEdit = (data, callback) => doRequest('addOrUpdateActivity', data, 'POST', callback)
// 关闭活动
const activityClose = (data, callback) => doRequest('closeActivity', data, 'GET', callback)
// 删除活动
const activityDelete = (data, callback) => doRequest('deleteActivity', data, 'GET', callback)
// 查询活动
const activityDetail = (data, callback) => doRequest('findActivityById', data, 'GET', callback)
// 所有活动
const activityList = (data, callback) => doRequest('findActivityList', data, 'POST', callback)
// 开启活动
const activityOpen = (data, callback) => doRequest('openActivity', data, 'GET', callback)
// 不分页查询所有活动
const activityAll = (data, callback) => doRequest('findActivitys', data, 'POST', callback)
// 藏品分类
const classifyList = (data, callback) => doRequest('findLotTypeList', data, 'POST', callback)
// 删除分类
const classifyDelete = (data, callback) => doRequest('deleteLotType', data, 'GET', callback)
// 分类详情
const classifyDetail = (data, callback) => doRequest('findLotTypeById', data, 'GET', callback)
// 分类编辑
const classifyEdit = (data, callback) => doRequest('addOrUpdateLotType', data, 'POST', callback)
// 所有商品分类
const classifyAll = (data, callback) => doRequest('findLotTypes', data, 'POST', callback)
// 藏品列表
const commodityList = (data, callback) => doRequest('findLotList', data, 'POST', callback)
// 藏品拍卖列表
const commodityAuctionList = (data, callback) => doRequest('findAuctionLotList', data, 'POST', callback)
// 藏品全部列表
const commodityAll = (data, callback) => doRequest('findLots', data, 'POST', callback)
// 藏品上链
const commodityAdd = (data, callback) => doRequest('addAuctionLot', data, 'POST', callback)
// 标签列表
const tagsList = (data, callback) => doRequest('findLabelList', data, 'POST', callback)
// 标签添加
const tagsAdd = (data, callback) => doRequest('addOrUpdateLabel', data, 'POST', callback)
// 标签删除
const tagsDelete = (data, callback) => doRequest('deleteLabel', data, 'GET', callback)
// 查询标签
const tagsDetail = (data, callback) => doRequest('findLabelById', data, 'GET', callback)
// 查询所有标签
const tagsAll = (data, callback) => doRequest('findLabels', data, 'POST', callback)
// 关注商品列表
const attentionCommodity = (data, callback) => doRequest('findFollowLotList', data, 'POST', callback)
// 商品关注用户列表
const attentionUserList = (data, callback) => doRequest('findFollowUserList', data, 'POST', callback)
// 创建拍卖品
const auctionGoodsAdd = (data, callback) => doRequest('createAuctionLot', data, 'POST', callback)
// 更新拍卖品
const auctionGoodsUpdate = (data, callback) => doRequest('updateAuctionLot', data, 'POST', callback)
// 上架
const auctionGoodsPutaway = (data, callback) => doRequest('upAuctionLot', data, 'GET', callback)
// 下架
const auctionGoodsSoldOut = (data, callback) => doRequest('downAuctionLot', data, 'GET', callback)
// 详情
const auctionGoodsDetail = (data, callback) => doRequest('findAuctionLotById', data, 'GET', callback)
// 拍卖记录
const auctionGoodsRecord = (data, callback) => doRequest('findBiddingRecord', data, 'GET', callback)
// 保证金记录
const auctionGoodsEarnest = (data, callback) => doRequest('findBondOrder', data, 'GET', callback)
// 释放保证金
const auctionGoodsRelease = (data, callback) => doRequest('refund', data, 'GET', callback)
// 全部释放
const auctionGoodsReleaseAll = (data, callback) => doRequest('refundAll', data, 'GET', callback)
// 订单记录
const orderList = (data, callback) => doRequest('findLotOrderList', data, 'POST', callback)
// 订单详情
const orderDetail = (data, callback) => doRequest('findLotOrderById', data, 'GET', callback)
// 网站设置
const webConfigSave = (data, callback) => doRequest('addOrUpdateDadeCompany', data, 'POST', callback)
// 网站设置详情
const webConfigDetail = (data, callback) => doRequest('findDadeCompanyList', data, 'POST', callback)
// 数据统计
const indexStatistics = (data, callback) => doRequest('findTongJi', data, 'GET', callback)
// 数据图标
const indexCharts = (data, callback) => doRequest('findYueCount', data, 'GET', callback)

// 前端接口
// 注册
const frontRegister = (data, callback) => doRequest('MemberApi/addOrUpdateMember', data, 'POST', callback)
// 实名
const frontReal = (data, callback) => doRequest('MemberApi/createAddress', data, 'POST', callback)
// 编辑头像
const frontAvatar = (data, callback) => doRequest('MemberApi/editAvatar', data, 'GET', callback)
// 登录
const frontLogin = (data, callback) => doRequest('MemberApi/fontLogin', data, 'POST', callback)
// 邮箱验证
const frontEmailVerify = (data, callback) => doRequest('MemberApi/inputEmailCode', data, 'POST', callback)
// 手机号校验
const frontPhoneVerify = (data, callback) => doRequest('MemberApi/inputPhoneCode', data, 'POST', callback)
// 发送邮件
const frontSendEmail = (data, callback) => doRequest('MemberApi/mail', data, 'GET', callback)
// 发送短信
const frontSendMsg = (data, callback) => doRequest('MemberApi/phone', data, 'GET', callback)
// 修改邮箱
const frontEmailEdit = (data, callback) => doRequest('MemberApi/updateEmail', data, 'POST', callback)
// 修改密码
const frontPasswordEdit = (data, callback) => doRequest('MemberApi/updatePassword', data, 'POST', callback)
// 修改手机号
const frontPhoneEdit = (data, callback) => doRequest('MemberApi/updatePhone', data, 'POST', callback)
// 查询用户详情
const frontUserInfo = (data, callback) => doRequest('MemberApi/findMemberById', data, 'GET', callback)
// 忘记密码
const forgetPassword = (data, callback) => doRequest('MemberApi/updatePwd', data, 'POST', callback)
// 收货地址列表
const frontAddressList = (data, callback) => doRequest('ReceiverAddressApi/findReceiverAddressList', data, 'POST',
	callback)
// 删除地址
const frontAddressDelete = (data, callback) => doRequest('ReceiverAddressApi/deleteReceiverAddress', data, 'GET',
	callback)
// 查询地址
const frontAddressDetail = (data, callback) => doRequest('ReceiverAddressApi/findReceiverAddressById', data, 'GET',
	callback)
// 新增地址
const frontAddressAdd = (data, callback) => doRequest('ReceiverAddressApi/addOrUpdateReceiverAddress', data, 'POST',
	callback)
// 设为默认
const frontAddressDefault = (data, callback) => doRequest('ReceiverAddressApi/setDefaultAddress', data, 'GET', callback)
// 轮播图列表
const frontIndexSlider = (data, callback) => doRequest('rotationApi/getRotationList', data, 'GET', callback)
// 商品分类
const frontCategory = (data, callback) => doRequest('lotTypeApi/getLotTypeList', data, 'GET', callback)
// 首页分类藏品列表-当天
const frontCommodityToday = (data, callback) => doRequest('AuctionLotApi/findTodayLotList', data, 'POST', callback)
// 商品详情
const frontCommodityDetail = (data, callback) => doRequest('AuctionLotApi/findAuctionLotById', data, 'GET', callback)
// 拍卖记录
const frontCommodityRecord = (data, callback) => doRequest('BiddingRecordApi/findBiddingRecordList', data, 'POST',
	callback)
// 文章分类
const frontArticleType = (data, callback) => doRequest('frontArticleApi/findArticleTypes', data, 'POST', callback)
// 文章列表
const frontArticleList = (data, callback) => doRequest('frontArticleApi/findArticles', data, 'POST', callback)
// 文章详情
const frontArticleDetail = (data, callback) => doRequest('frontArticleApi/findArticle', data, 'GET', callback)
// 藏品列表
const frontCommodityList = (data, callback) => doRequest('AuctionLotApi/findLotList', data, 'POST', callback)
// 网站设置
const frontWebConfig = (data, callback) => doRequest('AuctionLotApi/findDadeCompanyList', data, 'POST', callback)
// 报名拍卖
const frontJoinAuction = (data, callback) => doRequest('BondOrderApi/addBondOrder', data, 'POST', callback)
// 保证金列表
const frontDepositList = (data, callback) => doRequest('BondOrderApi/findBondOrders', data, 'POST', callback)
// 保证金详情
const frontDepositDetail = (data, callback) => doRequest('BondOrderApi/findBondById', data, 'GET', callback)
// 微信支付
const frontWxPay = (data, callback) => doRequest('PayApi/wxPay', data, 'POST', callback)
// 支付宝支付
const frontAliPay = (data, callback) => doRequest('PayApi/zfbPay', data, 'POST', callback)
// 查询订单状态
const frontOrderStatus = (data, callback) => doRequest('PayApi/query', data, 'GET', callback)
// 新增提醒
const frontOpenRemind = (data, callback) => doRequest('MyRemindApi/addMyRemind', data, 'POST', callback)
// 设置最高出价
const frontMaxPrice = (data, callback) => doRequest('AutoBidApi/addAutoBid', data, 'POST', callback)
// 新增收藏
const frontAddCollect = (data, callback) => doRequest('MyCollectionApi/addMyCollection', data, 'POST', callback)
// 取消收藏
const frontCancelCollect = (data, callback) => doRequest('MyCollectionApi/deleteMyCollection', data, 'GET', callback)
// 收藏列表
const frontCollectionList = (data, callback) => doRequest('MyCollectionApi/findMyCollectionList', data, 'POST', callback)
// 手动出价
const frontManualBid = (data, callback) => doRequest('BiddingRecordApi/addBiddingRecord', data, 'POST', callback)
// 添加浏览记录
const frontViewRecord = (data, callback) => doRequest('MyTracksApi/addOrUpdateMyTracks', data, 'POST', callback)
// 我的浏览记录
const frontViewList = (data, callback) => doRequest('MyTracksApi/findMyTracksList', data, 'POST', callback)
// 我的提醒列表
const frontRemindList = (data, callback) => doRequest('MyCollectionApi/findMyRemindList', data, 'POST', callback)
// 取消提醒
const frontRemindCancel = (data, callback) => doRequest('MyRemindApi/deleteMyRemind', data, 'GET', callback)
// 参拍藏品列表
const frontJoinList = (data, callback) => doRequest('MyCollectionApi/findMyCanPaiList', data, 'POST', callback)
// 已拍下藏品
const frontCompleteList = (data, callback) => doRequest('LotOrderApi/findLotOrders', data, 'POST', callback)
// 藏品详情
const frontAutionDetail = (data, callback) => doRequest('LotOrderApi/findLotById', data, 'GET', callback)
// 订单详情
const frontOrderDetail = (data, callback) => doRequest('LotOrderApi/findLotOrderById', data, 'GET', callback)
// 查询所有标签
const frontLabelList = (data, callback) => doRequest('MemberLabelApi/findLabels', data, 'POST', callback)
// 查询用户标签
const frontUserLabel = (data, callback) => doRequest('MemberLabelApi/queryMemberLabel', data, 'GET', callback)
// 保存标签
const frontUserSaveLabel = (data, callback) => doRequest('MemberLabelApi/setMemberLabel', data, 'GET', callback)
// 倒计时结束刷新藏品状态
const frontAuctionStausChange = (data, callback) => doRequest('AuctionLotApi/updateAuctionStatus', data, 'GET', callback)
// 查询拍卖结果
const frontQueryAuctionResult = (data, callback) => doRequest('LotOrderApi/queryOrderStatus', data, 'GET', callback)

export default {
	resetHeader,
	admlogin,
	admGetUserInfo,
	admEditPassword,
	admUserList,
	admUserAdd,
	admPasswordEdit,
	admUserStatus,
	admUserDelete,
	normalUserList,
	normalUserInfo,
	articleCategory,
	articleCategoryAll,
	articleCategoryAdd,
	articleCategoryDetail,
	articleCategoryDelete,
	articleList,
	articleDetail,
	articleEdit,
	articleDelete,
	swiperList,
	swiperDelete,
	swiperDetail,
	swiperEdit,
	activityEdit,
	activityClose,
	activityDelete,
	activityDetail,
	activityList,
	activityOpen,
	activityAll,
	classifyList,
	classifyDelete,
	classifyDetail,
	classifyEdit,
	classifyAll,
	commodityList,
	commodityAuctionList,
	commodityAll,
	commodityAdd,
	tagsList,
	tagsAdd,
	tagsDelete,
	tagsDetail,
	tagsAll,
	attentionCommodity,
	attentionUserList,
	auctionGoodsAdd,
	auctionGoodsUpdate,
	auctionGoodsPutaway,
	auctionGoodsSoldOut,
	auctionGoodsDetail,
	auctionGoodsRecord,
	auctionGoodsEarnest,
	auctionGoodsRelease,
	auctionGoodsReleaseAll,
	orderList,
	orderDetail,
	webConfigSave,
	webConfigDetail,
	frontRegister,
	frontReal,
	frontAvatar,
	frontLogin,
	frontEmailVerify,
	frontPhoneVerify,
	frontSendEmail,
	frontSendMsg,
	frontEmailEdit,
	frontPasswordEdit,
	frontPhoneEdit,
	frontUserInfo,
	forgetPassword,
	frontAddressList,
	frontAddressDelete,
	frontAddressDetail,
	frontCommodityRecord,
	frontAddressAdd,
	frontAddressDefault,
	frontIndexSlider,
	frontCategory,
	frontCommodityToday,
	frontCommodityDetail,
	frontArticleType,
	frontArticleList,
	frontArticleDetail,
	frontCommodityList,
	frontWebConfig,
	frontJoinAuction,
	frontDepositList,
	frontDepositDetail,
	frontWxPay,
	frontAliPay,
	frontOrderStatus,
	frontOpenRemind,
	frontMaxPrice,
	frontAddCollect,
	frontCancelCollect,
	frontCollectionList,
	frontManualBid,
	frontViewRecord,
	frontViewList,
	frontRemindList,
	frontRemindCancel,
	frontJoinList,
	frontCompleteList,
	frontAutionDetail,
	frontOrderDetail,
	indexStatistics,
	indexCharts,
	frontLabelList,
	frontUserLabel,
	frontUserSaveLabel,
	frontAuctionStausChange,
	frontQueryAuctionResult
}
